import { render, staticRenderFns } from "./PointSignin.vue?vue&type=template&id=890e408a&scoped=true&"
import script from "./PointSignin.vue?vue&type=script&lang=js&"
export * from "./PointSignin.vue?vue&type=script&lang=js&"
import style0 from "./PointSignin.vue?vue&type=style&index=0&id=890e408a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890e408a",
  null
  
)

export default component.exports